export const environmentv3 = {
  production: false,
  protocol: window["env"]["protocol"],
  apiroot: 'api/v3',
  host: window["env"]["host"],
  encryptType: window["env"]["encryptType"],
  saltMD5: window["env"]["saltMD5"],
  port: window["env"]["port"],
  context: window["env"]["context"],
  timeout: window["env"]["timeout"],
  requestTimeout: window["env"]["requestTimeout"] || 30000,
};
